
import { FC } from "react";
import { DialogModal, HPHButton } from "veronica-ui-component/dist/component/core";

export interface DialogModalProps {
    headerText: string
    contentText: any
    visible: boolean
    footerButtons?: Array<{
        label: string;
        theme: any;
        disableBadge?: boolean;
        onClick: () => void;
    }>;

    [x: string]: any
}



export const CommonMessageModal: FC<DialogModalProps> = ({
    headerText = 'headerText',
    contentText = 'contextText',
    visible = false,
    footerButtons
}) => {

    return (
        <DialogModal
            appendTo='self'
            showButton={false}
            visible={visible}
            positions="center"
            header={
                <>
                    <div className="modal-header">
                        <span className="name">{headerText}</span>
                    </div>
                    <div className="text">
                        <p style={{ whiteSpace: 'pre-line' }}>{contentText}</p>
                    </div>
                </>}
            className="delete-modal"
            dialogContent={<></>}
            footer={
                <div className="action-button">
                    {footerButtons?.map((item) => (
                        <HPHButton
                            label={item.label}
                            theme={item.theme}
                            disableBadge={item.disableBadge ?? true}
                            onClick={item.onClick}
                        />
                    ))}
                </div>
            }
        />
    )
}
    ;
